module.exports = __webpack_public_path__ + "static/media/organization-office-building-work.4069a9e5.svg";